export default "__VITE_PUBLIC_ASSET__c0632101__"